import React from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { Loader2, Check } from 'lucide-react';

const STEPS = [
  { key: 'upload', label: 'Uploading logo', hint: 'Pinning to IPFS' },
  { key: 'generate', label: 'Preparing contract', hint: 'Injecting your details' },
  { key: 'compile', label: 'Compiling', hint: 'Solidity 0.8.20 · OpenZeppelin' },
  { key: 'deploy', label: 'Deploy token', hint: 'Sign the first tx in your wallet' },
  { key: 'seed', label: 'Seed liquidity', hint: 'Sign the second tx: creates Uniswap pool, burns LP NFT' },
];

const ProgressModal = ({ open, currentStep, error, onClose }) => {
  const idx = STEPS.findIndex((s) => s.key === currentStep);
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v && (error || currentStep === 'done')) onClose?.(); }}>
      <DialogContent
        data-testid="progress-modal"
        className="bg-[#0B0A2A]/95 backdrop-blur-2xl border border-white/10 rounded-3xl text-white max-w-md"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <div className="space-y-1">
          <span className="cf-chip">Forging</span>
          <h3 className="font-display text-2xl font-bold mt-2">Launching your token</h3>
          <p className="text-sm text-forge-muted">Five steps · two wallet signatures. Don&apos;t close this window.</p>
        </div>
        <div className="mt-6 space-y-3">
          {STEPS.map((s, i) => {
            const done = i < idx || currentStep === 'done';
            const active = i === idx && currentStep !== 'done';
            return (
              <div key={s.key} data-testid={`progress-step-${s.key}`} className="flex items-start gap-3">
                <div className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all ${
                  done
                    ? 'bg-gradient-to-br from-[#7DF9FF] to-[#A78BFA] text-[#04121A]'
                    : active
                      ? 'bg-white/5 border border-[#7DF9FF]/60 cf-pulse'
                      : 'bg-white/5 border border-white/10'
                }`}>
                  {done && <Check className="w-4 h-4" />}
                  {active && <Loader2 className="w-4 h-4 animate-spin text-[#7DF9FF]" />}
                  {!done && !active && <span className="text-forge-muted text-xs">{i + 1}</span>}
                </div>
                <div className="flex-1">
                  <p className={`font-display font-medium text-sm ${done || active ? 'text-white' : 'text-forge-muted'}`}>{s.label}</p>
                  <p className="text-xs text-forge-muted mt-0.5">{s.hint}</p>
                </div>
              </div>
            );
          })}
        </div>
        {error && (
          <div data-testid="progress-error" className="mt-5 border border-[#FF6B7A]/40 bg-[#FF6B7A]/10 rounded-2xl p-4 text-[#FF6B7A] text-sm">
            {error}
          </div>
        )}
        {currentStep === 'done' && !error && (
          <p className="mt-5 text-sm text-[#7DF9FF] font-display">✨ Mint complete — opening your receipt…</p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ProgressModal;
